import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Table, Button, Form, Spinner } from 'react-bootstrap';
import { FiSearch, FiFilter, FiPlus, FiTruck, FiCalendar } from 'react-icons/fi';
import moment from 'moment';

import { AppContext } from '../AppContext';
import { tre } from '../trebus';

export default function Discrecionals() {
    const [discrecionals, setDiscrecionals] = useState({ data: [], current_page: 1, last_page: 1, total: 0 });
    const [searchString, setSearchString] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const context = useContext(AppContext);
    const navigate = useNavigate();

    // Load discrecional trips
    const loadDiscrecionals = (search = '') => {
        setIsLoading(true);
        tre.api('GET', `/companies/${context.idCompany}/trips/discrecionals`, {
            context: context,
            params: { search: search },
            success: (r) => {
                setDiscrecionals(r);
                setIsLoading(false);
            },
            error: () => setIsLoading(false)
        });
    };

    useEffect(() => {
        loadDiscrecionals(searchString);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchString]);

    const onSelectTrip = (trip) => {
        navigate(`/discrecional/${trip.id}`);
    };

    // -----| Render |-----
    return (
        <div className="container py-4">
            {/* Header */}
            <div className="d-flex align-items-center justify-content-between mb-4">
                <div>
                    <h4 className="mb-1" style={{ color: '#202124', fontWeight: 500 }}>
                        <FiTruck className="me-2" style={{ color: '#1a73e8' }} />
                        Viajes Discrecionales
                    </h4>
                    <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
                        {discrecionals.total || 0} viajes en total
                    </p>
                </div>
                <Button
                    variant="primary"
                    onClick={() => navigate('/discrecional/create')}
                >
                    <FiPlus className="me-2" />
                    Nuevo Viaje
                </Button>
            </div>

            {/* Filters - Inline style */}
            <div className="d-flex flex-wrap align-items-center gap-3 mb-4 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                {/* Search */}
                <div className="position-relative" style={{ minWidth: '280px', flex: 1, maxWidth: '400px' }}>
                    <FiSearch
                        className="position-absolute"
                        style={{ left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#5f6368' }}
                    />
                    <Form.Control
                        type="text"
                        placeholder="Buscar por nombre..."
                        value={searchString}
                        onChange={(e) => setSearchString(e.target.value)}
                        style={{ paddingLeft: '38px', backgroundColor: 'white' }}
                    />
                </div>

                {/* Clear filters - only show if filters active */}
                {searchString && (
                    <Button
                        variant="link"
                        size="sm"
                        onClick={() => setSearchString('')}
                        style={{ color: '#ea4335', textDecoration: 'none' }}
                    >
                        <FiFilter className="me-1" /> Limpiar
                    </Button>
                )}
            </div>

            {/* Table Card */}
            <Card>
                {/* Top Info */}
                {!isLoading && discrecionals.data && discrecionals.data.length > 0 && (
                    <Card.Header className="d-flex justify-content-between align-items-center py-3" style={{ backgroundColor: '#f8f9fa' }}>
                        <span style={{ fontSize: '14px', color: '#5f6368' }}>
                            <strong style={{ color: '#202124' }}>{discrecionals.total || 0}</strong> viajes
                        </span>
                    </Card.Header>
                )}

                <Card.Body className="p-0">
                    {isLoading ? (
                        <div className="text-center py-5">
                            <Spinner animation="border" style={{ color: '#1a73e8' }} />
                            <p className="mt-3 text-muted">Cargando viajes...</p>
                        </div>
                    ) : discrecionals.data && discrecionals.data.length > 0 ? (
                        <Table hover responsive className="mb-0">
                            <thead style={{ backgroundColor: '#f8f9fa' }}>
                                <tr>
                                    <th className="py-3 px-3" style={{ fontWeight: 500, color: '#5f6368', fontSize: '13px' }}>VIAJE</th>
                                    <th className="py-3" style={{ fontWeight: 500, color: '#5f6368', fontSize: '13px' }}>FECHA</th>
                                    <th className="py-3 text-end" style={{ fontWeight: 500, color: '#5f6368', fontSize: '13px' }}>PRECIO/PAS.</th>
                                    <th className="py-3 px-3 text-end" style={{ fontWeight: 500, color: '#5f6368', fontSize: '13px' }}>PRECIO TOTAL</th>
                                </tr>
                            </thead>
                            <tbody>
                                {discrecionals.data.map((trip) => (
                                    <tr
                                        key={trip.id}
                                        onClick={() => onSelectTrip(trip)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <td className="py-3 px-3">
                                            <div className="d-flex align-items-center">
                                                <div
                                                    className="d-flex align-items-center justify-content-center rounded-circle me-2"
                                                    style={{
                                                        width: '32px',
                                                        height: '32px',
                                                        backgroundColor: '#e8f0fe',
                                                        color: '#1a73e8'
                                                    }}
                                                >
                                                    <FiTruck size={16} />
                                                </div>
                                                <span style={{ color: '#202124', fontWeight: 500 }}>
                                                    {trip.name || '-'}
                                                </span>
                                            </div>
                                        </td>
                                        <td className="py-3">
                                            <span className="d-inline-flex align-items-center text-muted" style={{ fontSize: '14px' }}>
                                                <FiCalendar className="me-1" />
                                                {trip.date ? moment(trip.date).format('DD/MM/YYYY') : '-'}
                                            </span>
                                        </td>
                                        <td className="py-3 text-end">
                                            <span style={{ color: '#202124' }}>
                                                {trip.price_discrecional ? `${trip.price_discrecional} €` : '-'}
                                            </span>
                                        </td>
                                        <td className="py-3 px-3 text-end">
                                            <span style={{ fontWeight: 600, color: '#202124' }}>
                                                {trip.price_discrecional_total ? `${trip.price_discrecional_total} €` : '-'}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <div className="text-center py-5">
                            <FiTruck size={48} className="mb-3" style={{ color: '#dadce0' }} />
                            <p className="text-muted">No se encontraron viajes discrecionales</p>
                        </div>
                    )}
                </Card.Body>
            </Card>
        </div>
    );
}
